import { useMicdropState } from '@micdrop/react';
import { Micdrop } from '@micdrop/web';
import { useCallback } from 'react';

import { AuthGuard } from '@/features/common/components/AuthGuard';
import { useInterviewContext } from '@/features/common/contexts/interview.context';
import { useUserContext } from '@/features/common/contexts/user.context';
import {
  INTERVIEW_STEPS,
  InterviewFlowProvider,
} from '@/features/interview/contexts/interview-flow.context';
import InterviewScreen from '@/features/interview/pages/InterviewScreen';

export default function InterviewPage() {
  const { onReset } = useInterviewContext();
  const { user } = useUserContext();
  const { isStarted } = useMicdropState();

  const cancelInterview = useCallback(
    (step: INTERVIEW_STEPS) => {
      if (isStarted) Micdrop.stop();
      void onReset(step);
    },
    [isStarted, onReset],
  );

  // Allow passage if user exists in UserContext (first-time user who skipped OTP)
  // or if there's a BetterAuth session (returning user who verified OTP)
  const hasUser = Boolean(user?.id);

  return (
    <AuthGuard redirectTo="/otp" isAuthenticatedOverride={hasUser}>
      <InterviewFlowProvider>
        <InterviewScreen onCancel={cancelInterview} />
      </InterviewFlowProvider>
    </AuthGuard>
  );
}
